export default __webpack_public_path__ + "static/01_Sozialbau-45a7fbf1b33b7a2bb6ab4dc88ef7925a.jpg";